import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'externalURLs'
        ])
    },
    methods: {
        buildURLString (row, col, index) {
            if (!col.disabled) {
                var tempURL = col.refURL,
                    page = '',
                    searchResultsView = '/search/';

                switch (this.fromPage) {
                    case 'maps':
                        page = '/projects/map';
                        break;
                    case 'searchResults':
                    case 'projectDetails':
                    case 'publications':
                        break;
                    case 'publications-search':
                        searchResultsView = '';
                        break;
                    case 'circles':
                        page = '/projects/charts';
                        break;
                    case 'PressRelease':
                    case 'ResearchMatters':
                    case 'AIRS':
                    case 'ARRA':
                    case 'AIMRS':
                        page = '/news';
                        break;
                    default:
                        page = '/projects/' + this.fromPage;
                        break;
                }

                for (let i = 0; i < col.urlFields.length; i++) {
                    if (row[col.urlFields[i]] && Array.isArray(row[col.urlFields[i]])) {
                        tempURL = tempURL.replace('{{field' + i + '}}', row[col.urlFields[i]][index].toString().trim());
                    } else {
                        if (row[col.urlFields[i]])
                            tempURL = tempURL.replace('{{field' + i + '}}', row[col.urlFields[i]].toString().trim());
                    }
                }
                if (this.$route.params.search_id) {
                    tempURL = tempURL.replace('{{search_id}}', searchResultsView + this.$route.params.search_id + page);
                } else {
                    tempURL = tempURL.replace('{{search_id}}', '');
                }
                tempURL = tempURL.replace('{{report_url}}', this.externalURLs['report_base_url']);
                return tempURL;
            }
            return '';
        }
    }

}